import { render } from "./custom-text.vue?vue&type=template&id=0a8ae53b"
import script from "./custom-text.vue?vue&type=script&lang=js"
export * from "./custom-text.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__